import { type Component, Index } from 'solid-js'

import { Field, Select, createListCollection } from '@components'
import { type AssetTypeEnum, assetList } from '@here/api'
import { ChevronDownIcon } from 'lucide-solid'
import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { LastSelectDisabled } from './LastSelectDisabled'

export const AssetType: Component = () => {
	const { filters, setAssetType } = useService(useFilters)()

	const collection = createListCollection({ items: assetList })

	const selected = () => filters().assetType

	return (
		<Field.Root>
			<Field.Label>Market</Field.Label>
			<Select.Root
				positioning={{
					sameWidth: true,
				}}
				multiple
				value={selected()}
				collection={collection}
				onValueChange={({ value }) => setAssetType(value as AssetTypeEnum[])}
			>
				<Select.Control>
					<Select.Trigger>
						<Select.ValueText />
						<Select.Indicator>
							<ChevronDownIcon />
						</Select.Indicator>
					</Select.Trigger>
				</Select.Control>
				<Select.Positioner>
					<Select.Content>
						<Select.ItemGroup>
							<Index each={collection.items}>
								{(item) => (
									<LastSelectDisabled
										item={item()}
										selected={selected()}
									/>
								)}
							</Index>
						</Select.ItemGroup>
					</Select.Content>
				</Select.Positioner>
				<Select.HiddenSelect />
			</Select.Root>
		</Field.Root>
	)
}
